/**
 * Utility for handling boolean field conversions
 * Recursively walks through an object or array and converts
 * string 'true'/'false' values to actual booleans true/false.
 */
export const handleBooleanFields = <T>(data: T): T => {
  if (Array.isArray(data)) {
    data.forEach((item, index, arr) => {
      if (item !== null && typeof item === 'object') {
        arr[index] = handleBooleanFields(item);
      } else if (item === 'true' || item === 'false') {
        arr[index] = item === 'true';
      }
    });

    return data;
  }

  if (data !== null && typeof data === 'object') {
    const record = data as Record<string, any>;

    Object.keys(record).forEach((key) => {
      const value = record[key];

      if (value !== null && typeof value === 'object') {
        record[key] = handleBooleanFields(value);
      } else if (value === 'true' || value === 'false') {
        record[key] = value === 'true';
      }
    });
  }

  return data;
};
